import { useQuery } from 'react-query';

import { useRequest, type QueryFunction } from '../common';
import { getEventTypesListKey } from './keys';

// Fetch the list of non-internal event types.
export const useEventTypes: QueryFunction<
  unknown,
  [],
  ReturnType<typeof getEventTypesListKey>
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey: getEventTypesListKey(),
    queryFn: ({ signal }) =>
      request(`/events/types`, {
        init: {
          signal,
        },
      }),
  });
};

export default {
  useEventTypes,
};
